module.exports = __webpack_public_path__ + "static/img/rc_03.242b93d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/zh/rc_03.jpg
// module id = iUdx
// module chunks = 0